import React from 'react'
import { Button as PaperButton, useTheme } from 'react-native-paper'
import { View } from 'react-native'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle, webSpecificStyle } = helpers

export const CButton = ({ block = false, wrapperStyle, ...props }) => {
  const { colors } = useTheme()
  return (
    <View
      style={[{ alignItems: block ? 'strech' : 'flex-start' }, wrapperStyle]}
    >
      <PaperButton
        buttonColor={colors.accentText}
        uppercase={false}
        mode={props.mode || 'contained'}
        theme={{ roundness: 4 }}
        labelStyle={composeStyle(
          {
            fontSize: 16,
            padding: 2,
            display: 'flex',
            height: 30,
            alignItems: 'center',
          },
          webSpecificStyle({ userSelect: 'none' }),
        )}
        {...props}
      />
    </View>
  )
}
